import { Component, OnInit } from '@angular/core';
import { AccountService } from 'src/app/services/account.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-application',
  templateUrl: './application.component.html',
  styleUrls: ['./application.component.scss']
})
export class ApplicationComponent implements OnInit {
  public loadingApplication:boolean=true;
  private applicationId;
  public application:any;
  public newNote:string='';

  constructor(
    private _accounts: AccountService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _notify: NotificationService
  ) {
    this.applicationId=this._route.snapshot.paramMap.get("id");
  }

  ngOnInit() {
    this.getApplication();
  }

  public toggleContacted(oldStatus:number){
    let status=0;
    if(oldStatus==0) status=1;
    this._accounts.toggleApplicationContacted(this.applicationId, status).subscribe(
      res=>{
        this._notify.showMessage('Status updated', 'OK');
        this.getApplication();
      }
    );
  }

  private getApplication(){
    this._accounts.getApplication(this.applicationId).subscribe(
      res=>{
        this.application=res;
        this.loadingApplication=false;
      }
    );
  }

  public updateBillingDetails(){
    this._accounts.updateBillingDetails(this.application).subscribe(
      res=>{
        if (res.error) {
          this._notify.showMessage(res.error, 'OK');
        } else {
          this.application=res;
          this._notify.showMessage('Billing details updated.','OK');
        }
      }
    );
  }

  public addNote(){
    if(this.newNote=='') {
      this._notify.showMessage('You can not add an empty note', 'OK');
      return;
    }
    if(confirm('Confirm you want to add this note')) {
      this._accounts.addApplicationNote(this.applicationId, this.newNote).subscribe(
        res=>{
          this.application=res;
          this.newNote='';
          this._notify.showMessage('Note added', 'OK');
        }
      );
    }
  }

  public rejectApp(){
    if(confirm('Confirm you wish to reject this application, once rejected, it can not be later approved or moved back to pending.')){
      this._accounts.rejectApplication(this.applicationId).subscribe(
        res=>{
          this._notify.showMessage(res.message, 'OK');
          this._router.navigate(['/applications']);
        }
      );
    }
  }

  public approveApp(){
    if(confirm('Confirm approval of this application. Once approved, a practice will be created and the applicant set as the owner. An email will be sent to the applicant informing them of the approval and Practice creation.')){
      this._accounts.approveApplication(this.applicationId).subscribe(
        res=>{
          this._notify.showMessage(res.message, 'OK');
          this._router.navigate(['/applications']);
        }
      );
    }
  }
}
